export const isNonEmptyString = (str) => typeof str === 'string' && !!str;

export const isFunction = (fn) => typeof fn === 'function';
